import { c as _c } from "react/compiler-runtime";
import React from 'react';
import useProductAttributes from 'data-hooks/useProductAttributes/index';
import usePDPBasicDetails from 'components/consumer/PDP/state/context/usePDPBasicDetails';
import PDPInfoSectionLayout from './PDPInfoSectionLayout';

// Description tab: the copy PDPProductDescription shows in the rail today, minus
// the details-and-care link, which the layout revamp gives its own tab
const PDPInfoDescriptionSection = () => {
  const $ = _c(10);
  const {
    data: basicDetails
  } = usePDPBasicDetails();
  const {
    data: t0
  } = useProductAttributes();
  const {
    description,
    additional_attributes: additionalAttributes
  } = t0;
  const showpieceDesc = additionalAttributes?.showpiece_desc;
  const name = basicDetails?.name ?? "";
  const t1 = `${name} Description`;
  let t2;
  if ($[0] !== t1) {
    t2 = t1.trim();
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  let t3;
  if ($[2] !== description) {
    t3 = !!description && <p className="text-sm text-gray mt-0 mx-0 mb-4">{description}</p>;
    $[2] = description;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] !== showpieceDesc) {
    t4 = !!showpieceDesc && <p className="text-sm text-gray m-0">{showpieceDesc}</p>;
    $[4] = showpieceDesc;
    $[5] = t4;
  } else {
    t4 = $[5];
  }
  let t5;
  if ($[6] !== t2 || $[7] !== t3 || $[8] !== t4) {
    t5 = <PDPInfoSectionLayout heading={t2}>{t3}{t4}</PDPInfoSectionLayout>;
    $[6] = t2;
    $[7] = t3;
    $[8] = t4;
    $[9] = t5;
  } else {
    t5 = $[9];
  }
  return t5;
};
export default PDPInfoDescriptionSection;